import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosRDV } from "../../../api/axios"; 
import { ROOM_PATHS } from "../../../api/endpoints"; 

// 1) Créer une room (médecin)
export const createRoom = createAsyncThunk(
  "rooms/createRoom",
  async ({ appointmentId, payload = {} }, { rejectWithValue }) => {
    try {
      const { data } = await axiosRDV.post(
        ROOM_PATHS.CREATE(appointmentId),
        payload
      );
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

// 2) Créer une room "à l'arrivée" (médecin)
export const createRoomOnArrival = createAsyncThunk(
  "rooms/createRoomOnArrival",
  async ({ appointmentId }, { rejectWithValue }) => {
    try {
      const { data } = await axiosRDV.post(
        ROOM_PATHS.CREATE_ON_ARRIVAL(appointmentId),
        {}
      );
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

// 3) Récupérer la room d'un rendez-vous (patient ou médecin)
export const fetchRoomByAppointment = createAsyncThunk(
  "rooms/fetchRoomByAppointment",
  async ({ appointmentId }, { rejectWithValue }) => {
    try {
      const { data } = await axiosRDV.get(
        ROOM_PATHS.BY_APPOINTMENT(appointmentId)
      );
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

// 4) Récupérer toutes les rooms (médecin)
export const fetchAllRooms = createAsyncThunk(
  "rooms/fetchAllRooms",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axiosRDV.get(ROOM_PATHS.ALL());
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

// 5) Récupérer les rooms par statut (médecin)
export const fetchRoomsByStatus = createAsyncThunk(
  "rooms/fetchRoomsByStatus",
  async ({ status }, { rejectWithValue }) => {
    try {
      const { data } = await axiosRDV.get(ROOM_PATHS.BY_STATUS(status));
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

// 6) Récupérer les rooms par docteur (médecin)
export const fetchRoomsByDoctor = createAsyncThunk(
  "rooms/fetchRoomsByDoctor",
  async ({ doctorId }, { rejectWithValue }) => {
    try {
      const { data } = await axiosRDV.get(ROOM_PATHS.BY_DOCTOR(doctorId));
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

// 7) Récupérer les rooms par patient (patient ou médecin)
export const fetchRoomsByPatient = createAsyncThunk(
  "rooms/fetchRoomsByPatient",
  async ({ patientId }, { rejectWithValue }) => {
    try {
      const { data } = await axiosRDV.get(ROOM_PATHS.BY_PATIENT(patientId));
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

// 8) Récupérer une room par id (patient ou médecin)
export const fetchRoomById = createAsyncThunk(
  "rooms/fetchRoomById",
  async ({ roomId }, { rejectWithValue }) => {
    try {
      const { data } = await axiosRDV.get(ROOM_PATHS.BY_ID(roomId));
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

// 9) Mettre à jour le statut d'une room (médecin)
export const updateRoomStatus = createAsyncThunk(
  "rooms/updateRoomStatus",
  async ({ roomId, status }, { rejectWithValue }) => {
    try {
      const { data } = await axiosRDV.patch(
        ROOM_PATHS.UPDATE_STATUS(roomId, status),
        {}
      );
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

// 10) Supprimer une room (médecin)
export const deleteRoom = createAsyncThunk(
  "rooms/deleteRoom",
  async ({ roomId }, { rejectWithValue }) => {
    try {
      await axiosRDV.delete(ROOM_PATHS.DELETE(roomId));
      // on renvoie roomId pour que le reducer puisse la retirer du state
      return { roomId };
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);
